import { POWERUP_COSTS } from '../economy/economyCatalog';

export const RIDDLE_DIFFICULTY = Object.freeze({
  HARD: 'hard',
  EASY: 'easy',
});

export const isValidRiddleDifficulty = (value) =>
  value === RIDDLE_DIFFICULTY.HARD || value === RIDDLE_DIFFICULTY.EASY;

export const getRiddleBaseCostForDifficulty = (difficulty) => {
  const base = POWERUP_COSTS.riddle_base;
  const bonus = POWERUP_COSTS.riddle_easy_bonus || 0;
  return difficulty === RIDDLE_DIFFICULTY.EASY ? base + bonus : base;
};

export const getRiddleEarlyGuessSurcharge = ({ guessRow }) => {
  const surcharge = POWERUP_COSTS.riddle_early_guess_surcharge || 0;
  if (!surcharge) return 0;

  // Note: if guessRow is missing/invalid, default to "early round"
  // so pricing stays conservative and consistent across callers.
  const row = Number.isFinite(guessRow) ? Math.floor(guessRow) : null;
  if (row === null) return surcharge;
  return row <= 1 ? surcharge : 0;
};

export const getRiddleNextCost = ({ useCount, difficulty, guessRow }) => {
  const repeats = typeof useCount === 'number' && useCount > 0 ? useCount : 0;
  return (
    getRiddleBaseCostForDifficulty(difficulty) +
    repeats * POWERUP_COSTS.riddle_repeat_increment +
    getRiddleEarlyGuessSurcharge({ guessRow })
  );
};

